var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkleWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11950_288179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24Z",
    fill: "url(#paint0_linear_11950_288179)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11950_288179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9167 27.9974C27.2703 27.9974 27.6094 28.1379 27.8595 28.3879C28.1095 28.638 28.25 28.9771 28.25 29.3307C28.25 28.9771 28.3905 28.638 28.6405 28.3879C28.8906 28.1379 29.2297 27.9974 29.5833 27.9974C29.2297 27.9974 28.8906 27.8569 28.6405 27.6069C28.3905 27.3568 28.25 27.0177 28.25 26.6641C28.25 27.0177 28.1095 27.3568 27.8595 27.6069C27.6094 27.8569 27.2703 27.9974 26.9167 27.9974ZM26.9167 19.9974C27.2703 19.9974 27.6094 20.1379 27.8595 20.3879C28.1095 20.638 28.25 20.9771 28.25 21.3307C28.25 20.9771 28.3905 20.638 28.6405 20.3879C28.8906 20.1379 29.2297 19.9974 29.5833 19.9974C29.2297 19.9974 28.8906 19.8569 28.6405 19.6069C28.3905 19.3568 28.25 19.0177 28.25 18.6641C28.25 19.0177 28.1095 19.3568 27.8595 19.6069C27.6094 19.8569 27.2703 19.9974 26.9167 19.9974ZM22.25 27.9974C22.25 26.9365 22.6714 25.9191 23.4216 25.169C24.1717 24.4188 25.1891 23.9974 26.25 23.9974C25.1891 23.9974 24.1717 23.576 23.4216 22.8258C22.6714 22.0757 22.25 21.0583 22.25 19.9974C22.25 21.0583 21.8286 22.0757 21.0784 22.8258C20.3283 23.576 19.3109 23.9974 18.25 23.9974C19.3109 23.9974 20.3283 24.4188 21.0784 25.169C21.8286 25.9191 22.25 26.9365 22.25 27.9974Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11950_288179",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_11950_288179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11950_288179",
    x1: 24,
    y1: 8,
    x2: 24,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#853CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01D5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11950_288179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16.25 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleWithBg);
export default __webpack_public_path__ + "static/media/sparkle_with_bg.fe43de38ec2fd782c3dcc4b48569908f.svg";
export { ForwardRef as ReactComponent };